import $ from 'jquery';
import * as bootstrap from 'bootstrap';
import DataTable from 'datatables.net';
import language from 'datatables.net-plugins/i18n/ru.mjs';
import 'datatables.net-responsive';
import 'datatables.net-columncontrol-dt';

window.$ = window.jQuery = $;
window.bootstrap = bootstrap;

let ratingTable;

const ruColumnControlTranslations = {
  columnControl: {
    orderAsc: 'По возрастанию',
    orderDesc: 'По убыванию',
    order: 'Сортировка',
    search: 'Поиск',
    buttons: {
      columnControl: 'Управление колонками',
    },
    list: {
      search: 'Поиск',
      empty: 'Нет',
    },
  },
};

$(function () {
  'use strict';

  if ($('#cookies-widget').length) {
    if (!getCookie('cookieAlertShowed')) {
      $('#cookies-widget').addClass('show');
    }
  }

  $('#cookies-widget #cookies-ok').click(function () {
    setCookie('cookieAlertShowed', true, 365);
    $('#cookies-widget').removeClass('show');
  });

  const offcanvasNavbar = new bootstrap.Offcanvas('#offcanvasDarkNavbar');

  $('.top-menu .navbar-toggler').on('click', function (event) {
    event.preventDefault();
    offcanvasNavbar.toggle();
  });

  $('.go-to').click(function (e) {
    const linkUrl = new URL(this.href);
    const currentUrl = new URL(window.location);
    if (linkUrl.pathname === currentUrl.pathname) {
      e.preventDefault();
      e.stopPropagation();
    }

    offcanvasNavbar.hide();
    const scrollTarget = $(this.hash);
    if (scrollTarget.length) {
      const scrollTargetOffsetTop = scrollTarget.offset().top;

      scrollTop(scrollTarget, scrollTargetOffsetTop);
      return false;
    }
  });

  $(window).on('scroll', function () {
    const scrollLineContainer = $('.with-scroll-line');
    if (scrollLineContainer.length) {
      $.each(scrollLineContainer, function (i, element) {
        const scrollLineContainer = $(element);
        const line = scrollLineContainer.find('.progress-line');
        if (line.length) {
          const containerTop = scrollLineContainer.offset().top;
          const containerHeight = scrollLineContainer.outerHeight();
          const scrollTopPos = $(window).scrollTop();
          const windowHeight = $(window).height();

          const scrollProgress = Math.min(
            Math.max((scrollTopPos + windowHeight / 2 - containerTop) / containerHeight, 0),
            1,
          );

          const maxTranslate = containerHeight - 150 - 140;
          const translateY = scrollProgress * maxTranslate;

          line.css('transform', `translateY(${translateY}px)`);
        }
      });
    }
  });

  if ($('.horizontal-sticky-scroll').length) {
    const horizontalStickyScroll = $('.horizontal-sticky-scroll');
    const spaceHolder = horizontalStickyScroll.find('.space-holder');
    const horizontal = horizontalStickyScroll.find('.horizontal');
    const sticky = horizontalStickyScroll.find('.sticky');
    if (spaceHolder.length && horizontal.length && sticky.length) {
      spaceHolder.height(`${calcDynamicHeight(horizontal)}px`);

      $(window).on('scroll', function () {
        horizontal.css('transform', `translateX(-${sticky[0].offsetTop}px)`);
      });

      $(window).on('resize', function () {
        spaceHolder.height(`${calcDynamicHeight(horizontal)}px`);
      });
    }

    const scale = window.devicePixelRatio;

    if (scale === 1.25) {
      horizontalStickyScroll.addClass('scale-125');
    } else if (scale === 1.5) {
      horizontalStickyScroll.addClass('scale-150');
    } else if (scale === 1.75) {
      horizontalStickyScroll.addClass('scale-175');
    }
  }

  function calcDynamicHeight(ref) {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const objectWidth = ref[0].scrollWidth;
    return objectWidth - vw + vh + 150;
  }

  $('input[type="tel"]').each(function () {
    const $this = $(this);
    const originalPlaceholder = $this.attr('placeholder');

    $this.on('focus', function () {
      if (!$this.val().startsWith('+')) {
        $this.val('+');
      }
      $this.attr('placeholder', '');
    });

    $this.on('blur', function () {
      if ($this.val() === '+') {
        $this.val('');
      }
      $this.attr('placeholder', originalPlaceholder);
    });

    $this.on('input', function () {
      const cursorPosition = this.selectionStart;
      let value = $this.val();

      if (!value.startsWith('+')) {
        value = '+' + value.replace(/[^0-9]/g, '');
      } else {
        value = '+' + value.slice(1).replace(/[^0-9]/g, '');
      }

      if ($this.val() !== value) {
        $this.val(value);
        this.setSelectionRange(cursorPosition, cursorPosition);
      }
    });

    $this.on('keydown', function (e) {
      if (this.selectionStart === 1 && this.selectionEnd === 1 && e.key === 'Backspace') {
        e.preventDefault();
      }
    });
  });

  if ($('#rating-table').length) {
    ratingTable = new DataTable('#rating-table', {
      language: { ...language, ...ruColumnControlTranslations },
      responsive: true,
      autoWidth: true,
      pageLength: 12,
      columnControl: ['order', ['searchList']],
      ordering: {
        indicators: false,
        handler: false,
      },
      order: [[0, '']],
      columnDefs: [
        {
          targets: [1],
          columnControl: [
            'order',
            [
              {
                extend: 'searchList',
                search: false,
                select: true,
              },
            ],
          ],
        },
        {
          targets: [2],
          columnControl: ['order'],
        },
        { responsivePriority: 1, targets: [0, 2] },
        { responsivePriority: 10001, targets: '_all' },
      ],
      initComplete: function () {
        const table = this.api();
        const container = this.closest('.navigation');
        const preloader = container.find('.table-preloader');
        const searchBox = container.find('.search-box');
        const nativeSearch = container.find('.dt-search');
        nativeSearch.find('input').attr('placeholder', 'поиск...');
        searchBox.append(nativeSearch);

        container.find('.dt-length').closest('.dt-layout-row').addClass('table-header');
        container.find('.dt-paging').closest('.dt-layout-row').addClass('table-footer');

        $('#dt-reset-filter').on('click', function () {
          const params = new URLSearchParams(document.location.search);
          if (params.has('status')) {
            window.location = window.location.pathname;
          }

          table.search('').draw();
          $('.dt-search input').val('');

          table.columns().every(function () {
            this.search('').draw();
          });

          table.columns().columnControl.searchClear();
          table.draw().order([[0, '']]);

          if (table.state) {
            table.state.clear();
          }

          table.draw();
        });

        setTimeout(() => {
          preloader.addClass('hide');
          this.addClass('loaded').show();
        }, 500);
      },
    });

    window.ratingTable = ratingTable;
  }
});

function scrollTop(target, position) {
  $('html,body').animate(
    {
      scrollTop: position,
    },
    1000,
    function () {
      setTimeout(function () {
        const realPosition = target.offset().top;
        if (realPosition > position) {
          scrollTop(target, realPosition);
        }
      }, 200);
    },
  );
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
  const name = cname + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
